import { useCallback, type FC } from 'react';
import {
  useMediaPlayerActions,
  useMediaPlayerState
} from '@/react/components/core-ui/Video/MediaPlayer';

import { Icon, IconTypes, IconSizeProp } from '@/react/components/core-ui/Icon';
import S from './styles.module.scss';

/**
 * The custom player icons that can be overlayed over the video.
 */
export const PlaybackButton: FC = () => {
  const { isPlaying } = useMediaPlayerState();
  const { play, pause } = useMediaPlayerActions();

  const togglePlayback = useCallback((): void => {
    if (isPlaying) pause();
    else play();
  }, [isPlaying, pause, play]);

  return (
    <button
      className={S.container}
      onClick={togglePlayback}
      type="button"
      aria-label={isPlaying ? 'Pause' : 'Play'}
    >
      {!isPlaying && (
        <Icon
          className={S.icon}
          icon={IconTypes.PlayRegular}
          size={IconSizeProp.SizeLG}
        />
      )}
    </button>
  );
};
